// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"Checkbox__wrapper","lg":"Checkbox__lg","md":"Checkbox__md","onCheckbox":"Checkbox__on-checkbox","offCheckbox":"Checkbox__off-checkbox","disabled":"Checkbox__disabled"};